class ResourceLoader {
	private resourceCache = new Map<string, Promise<void>>();

	public load(type: 'style' | 'script', path: string): Promise<void> {
		if (this.resourceCache.has(path)) {
			return this.resourceCache.get(path)!;
		}

		if (
			(type === 'style' && document.querySelector(`link[href="${path}"]`)) ||
			(type === 'script' && document.querySelector(`script[src="${path}"]`))
		) {
			const resolvedPromise = Promise.resolve();
			this.resourceCache.set(path, resolvedPromise);
			return resolvedPromise;
		}

		const promise = new Promise<void>((resolve, reject) => {
			if (type === 'style') {
				this.loadStyle(path, resolve, reject);
				return;
			}

			this.loadScript(path, resolve, reject);
		});

		this.resourceCache.set(path, promise);

		return promise;
	}

	private loadStyle(path: string, resolve: () => void, reject: (err: Error) => void): void {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = path;

		link.onload = () => resolve();
		link.onerror = () => {
			this.resourceCache.delete(path);
			reject(new Error(`Failed to load style: ${path}`));
		};

		document.head.appendChild(link);
	}

	private loadScript(path: string, resolve: () => void, reject: (err: Error) => void): void {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = path;
		script.async = false;

		script.onload = () => resolve();
		script.onerror = () => {
			this.resourceCache.delete(path);
			reject(new Error(`Failed to load script: ${path}`));
		};

		document.body.appendChild(script);
	}
}

const resourceLoader = new ResourceLoader();
export default resourceLoader;
